














import { Component, Prop } from 'vue-property-decorator';
import { dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import { Expandable } from './Accordion.vue';
import BaseComponent from './Base';

@Component
export default class AccordionItem extends BaseComponent implements Expandable {
    protected isOpened: boolean = false;
    @Prop({ type: [Number, Boolean], default: undefined }) protected readonly index: number | undefined;

    public isExpanded(): boolean {
        return this.isOpened;
    }

    public expand(state?: boolean): void {
        this.isOpened = state || !this.isOpened;
        this.$nextTick(() => {
            if (this.isOpened) {
                EventBus.$emit('updateSwipers');
            }
        });
    }

    public getIndex(): number | undefined {
      return this.index;
    }

    protected onClick(): void {
        const pvm: any = this.$parent;
        const titleEl: any = this.$el.childNodes[0];
        if (this.isOpened) {
            dataLayer.push({
                eventAction: 'Folded',
                eventLabel: 'Folded ' + titleEl.innerText,
                eventCategory: pvm.gtmCategory,
                event: 'accordion:folded',
            });
        } else {
            dataLayer.push({
                eventAction: 'Expanded',
                eventLabel: 'Expanded ' + titleEl.innerText,
                eventCategory: pvm.gtmCategory,
                event: 'accordion:expanded',
            });
        }
        this.expand();
    }

    protected beforeMount(): void {
        // TODO: find a better way to do class merge
        if (this.$vnode.data) {
            // this.$vnode.data.staticClass = '';
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccordionItem.vue